var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourReqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9289 9.22222H15.9684L11.4068 1.23871C11.346 1.13242 11.2581 1.04409 11.1522 0.982658C11.0462 0.921227 10.926 0.888878 10.8035 0.888885L7.96061 0.888885C7.49923 0.888885 7.16633 1.33029 7.29307 1.77387L9.42111 9.22222H4.9567L3.0817 6.72222C2.95062 6.54731 2.74446 6.44444 2.52614 6.44444H0.790466C0.338644 6.44444 0.00704637 6.86892 0.116855 7.30729L1.48448 12L0.116855 16.6927C0.00704637 17.1311 0.338644 17.5556 0.790466 17.5556H2.52614C2.74489 17.5556 2.95062 17.4527 3.0817 17.2778L4.9567 14.7778H9.42111L7.29307 22.2257C7.16633 22.6693 7.49923 23.1111 7.96061 23.1111H10.8035C11.0526 23.1111 11.2827 22.9774 11.4064 22.7613L15.9684 14.7778H20.9289C22.4632 14.7778 25.0956 13.5343 25.0956 12C25.0956 10.4657 22.4632 9.22222 20.9289 9.22222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourReqIcon);
export default __webpack_public_path__ + "static/media/YourReqIcon.cd2aa7e33e49d7d3e74dd09108847973.svg";
export { ForwardRef as ReactComponent };